/*jshint esversion: 6 */
/*jshint strict: false */

import * as d3 from 'd3';

let data = [];

function setupGraph() {

    let svg = d3.select(".highest-rated .graph svg");

    svg.selectAll("*").remove();

    svg.attr('width', svg.node().getBoundingClientRect().width);
    svg.attr('height', svg.node().getBoundingClientRect().width / 1.8);

    let margin = {top: 50, right: 50, bottom: 40, left: 50},
        width = +svg.attr("width") - margin.left - margin.right,
        height = +svg.attr("height") - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    let xScale = d3.scaleLinear()
        .domain([-0.5, data.length])
        .range([0, width]);

    let yScale = d3.scaleLinear()
        .domain([0, 10])
        .range([height, 0]);

    let xAxis = d3.axisBottom()
        .scale(xScale)
        .ticks(0);

    let yAxis = d3.axisLeft()
        .scale(yScale)
        .ticks(5);

    let tooltip = svg.select(function() { return this.parentNode; })
        .append("div")
        .attr("class", "tooltip")
        .style("opacity", 0);

    var gAxisX = g.append('g')
        .attr('transform', 'translate(0,' + height + ')')
        .attr('class', 'axis axis-x')
        .call(xAxis);

    gAxisX.append("text")
        .attr('x', width / 2)
        .attr('y', 20)
        .text("Franchises");

    gAxisX.append("text")
        .attr('x', width / 2)
        .attr('y', 40)
        .text("Hover over the chart to see the individual films");

    g.append('g')
        .attr('class', 'axis axis-y')
        .call(yAxis)
        .append("text")
        .attr('x', -20)
        .attr('y', -20)
        .text("Scores");

    let gData = g.append("g")
        .attr('class', 'data');

    let lineAverage = d3.line()
        .x(function (d, i) {
            return xScale(i);
        })
        .y(function (d) {
            return yScale(d.average);
        });

    gData.append("path")
        .datum(data)
        .attr("class", "average")
        .attr("d", lineAverage);

    gData.selectAll("circle.average")
        .data(data)
        .enter()
        .append("circle")
        .attr('class', 'average')
        .attr("cx", function (d, i) {
            return xScale(i);
        })
        .attr("cy", function (d) {
            return yScale(d.average);
        })
        .attr("r", 4)
        .on("mouseover", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", .9);
            tooltip.html(getTooltip(d))
                .style("left", (d3.event.pageX) + "px")
                .style("top", (d3.event.pageY - 28) + "px");
        })
        .on("mouseout", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", 0);
        });

    gData.selectAll("circle.imdb")
        .data(data)
        .enter()
        .append("circle")
        .attr('class', 'imdb')
        .attr("cx", function (d, i) {
            return xScale(i);
        })
        .attr("cy", function (d) {
            return yScale(d.imdb);
        })
        .attr("r", 4)
        .on("mouseover", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", .9);
            tooltip.html(getTooltip(d))
                .style("left", (d3.event.pageX) + "px")
                .style("top", (d3.event.pageY - 28) + "px");
        })
        .on("mouseout", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", 0);
        });

    gData.selectAll("circle.rotten")
        .data(data)
        .enter()
        .append("circle")
        .attr('class', 'rotten')
        .attr("cx", function (d, i) {
            return xScale(i);
        })
        .attr("cy", function (d) {
            return yScale(d.rottentomato / 10);
        })
        .attr("r", 4)
        .on("mouseover", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", .9);
            tooltip.html(getTooltip(d))
                .style("left", (d3.event.pageX) + "px")
                .style("top", (d3.event.pageY - 28) + "px");
        })
        .on("mouseout", function (d) {
            tooltip.transition()
                .duration(500)
                .style("opacity", 0);
        });


    let gLegend = g.append("g")
        .attr('class', 'legend')

    var legendData = {
        'rotten': 'Rotten Tomatoes',
        'imdb': 'IMDb Score',
        'average': 'Average Score'
    };

    var i = 0;
    for(let key in legendData) {

        let legendItem = gLegend.append('g');

        legendItem
            .append('circle')
            .attr('class', key)
            .attr('r', 4)
            .attr("cx", 30)
            .attr("cy", height - 29 - (i * 20));

        legendItem
            .append('text')
            .text(legendData[key])
            .attr("x", 40)
            .attr("y", height - 25 - (i * 20));

        i++;
    }

}

function getTooltip(d) {
    return '<div class="tooltip-title">' + d.franchise + '</div><div class="tooltip-scores">' +
        '<div class="circle average"></div>' + d.average +
        '<div class="circle imdb"></div>' + d.imdb +
        '<div class="circle rotten"></div>' + d.rottentomato + '%</div>';
}

function populateTable() {

    let table = d3.select(".highest-rated .content-table table tbody");

    let tr = table.selectAll("tr")
        .data(data)
        .enter()
        .append("tr");

    tr.append("td").text(function (d) {
        return d.franchise;
    });

    tr.append("td").text(function (d) {
        return d.imdb;
    });

    tr.append("td").text(function (d) {
        return d.rottentomato + '%';
    });

    tr.append("td").text(function (d) {
        return d.average;
    });

}

function loadData(dataDir) {

    d3.csv(dataDir + "highest-rated.csv", function (csvData) {
        csvData.forEach(function (d) {
            d.imdb = +d.imdb;
            d.rottentomato = +d.rottentomato.replace('%', '');
            d.average = +d.average;
        });

        delete csvData['columns'];
        data = csvData;
        populateTable();
        setupGraph();
    });
}

function init(dataDir) {
    loadData(dataDir);
    window.addEventListener("resize", setupGraph);
}


export {init}


// WEBPACK FOOTER //
// ./highest-rated.js